import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  loadingIcon: {
    marginRight: theme.spacing(1),
  },
}));
